module.exports = __webpack_public_path__ + "img/logo.de189a1f.jpg";